import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useObserveHero = () => {
  const [isHeroVisible, setIsHeroVisible] = useState(true);
  const route = useRouter();

  useEffect(() => {
    const heroComponents = ['CoreHero', 'CoreHomeHero', 'CorePeopleHero', 'ArticleHero'];

    const hero = heroComponents
      .map((componentName) => document.querySelector(`[data-component="${componentName}"]`))
      .filter(Boolean)[0];

    if (hero) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsHeroVisible(entry.isIntersecting);
        },
        {
          threshold: 0.95,
        }
      );

      observer.observe(hero);
      return () => {
        observer.disconnect();
      };
    } else {
      setIsHeroVisible(false);
    }
    return;
  }, [route.asPath]);

  return { isHeroVisible };
};
